// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"47":"0dea1f0c","198":"2c46df70","212":"906770b4","326":"dbeb346b","421":"96cc46bf","772":"543b8c1d","898":"0b3aa14c"}[chunkId] + ".chunk.js";
};